const GRADIENT_SCHEMES = new Set([
    'gradient',
    'dark-gradient',
    'light-gradient',
    'light-primary-gradient',
    'primary-gradient',
    'dark-primary-gradient',
    'dark-secondary-gradient',
    'secondary-gradient',
    'light-secondary-gradient',
    'mid-gradient',
]);

export function clampGradientAngle(value) {
    const parsed =
        typeof value === 'number' ? value : Number.parseFloat(String(value));
    if (!Number.isFinite(parsed)) {
        return 180;
    }
    const normalizedAngle = Math.round(parsed) % 360;
    if (normalizedAngle < 0) {
        return normalizedAngle + 360;
    }
    return normalizedAngle;
}

export function getGradientDirectionDegrees(value) {
    return `${clampGradientAngle(value)}deg`;
}

export function isGradientColorScheme(value) {
    return GRADIENT_SCHEMES.has(
        String(value || '')
            .trim()
            .toLowerCase()
    );
}
